<template>
    <div class="layout" v-bind:class="{nopadding:($route.name === 'login')}">
    <LayoutMenu v-if="$route.name !== 'login'"></LayoutMenu>
    <LayoutHeader v-if="$route.name !== 'login'"></LayoutHeader>
    <transition name="fade" mode="out-in" appear>
      <router-view />
    </transition>
    <ModalsContainer />
    <flash-message :transition-name="'fadeDownRight'" class="flash-message-wrapper" />
  </div>
</template>

<script>
import LayoutMenu from './layout/menu/LayoutMenu.vue';
import LayoutHeader from './layout/header/LayoutHeader.vue';

export default {
  name: 'App',
  components: {
    LayoutMenu,
    LayoutHeader,
  },
  data() {
    return {};
  },
  mounted() {
    const storageTimeFormat = window.localStorage.getItem('tentacles-time-format');
    const storageNameFormat = window.localStorage.getItem('tentacles-name-format');
    const storageNetwork = window.localStorage.getItem('tentacles-network');
    if (storageTimeFormat !== null) {
      this.$store.dispatch('tentacle/setTimeFormat', storageTimeFormat === 'true');
    }
    if (storageNameFormat !== null) {
      this.$store.dispatch('tentacle/setNameFormat', storageNameFormat === 'true');
    }
    if (storageNetwork !== null) {
      this.$store.dispatch('tentacle/setNetwork', storageNetwork === 'true');
    }
  },
  watch: {
    $route(newRoute, oldRoute) {
      const newLang = newRoute.params.lang.toUpperCase();
      const oldLang = this.$i18n.locale;
      if (newLang !== oldLang) {
        this.$i18n.locale = newLang;
      }
    },
  },
};
</script>

<style lang="scss">
@import './styles/global.scss';
.nopadding {
    padding: 0 !important;
}
.layout {
  width: 100%;
  height: auto;
  min-height: 100vh;
  padding: 7rem 0 0 8rem;
  background-color: $bg;
  @media only screen and (max-width: 991px) {
      padding: 10rem 0 0 0;
  }
}

.flash-message-wrapper {
  position: fixed;
  z-index: 100;
  top: 9rem;
  right: 2rem;
  max-height: 40rem;
  width: 26rem;
  perspective: 40rem;
}
</style>
